import React from 'react';
import {PatternBackground} from "../../components/PatternBackground";
import { useLocation } from "react-router-dom"
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';

const StatementGenerationPreview = () => {

    const location = useLocation();
    // eslint-disable-next-line no-unused-vars
    const { type } = location.state || {};

    return (
        <div>
            <PatternBackground>
                <p className="lead fw-bold">Statement Generation Preview</p>
                <small>Preview</small>
            </PatternBackground>
            <div className="om-container">
                <div className='p-4 shadow-sm bg-white rounded'>
                    <p className="lead mb-2">Year in Reference</p>
                    <p>1997</p>

                    <div className='mt-5'>
                        <p className='lead mb-5'>Members</p>
                        <div className="row align-items-center mb-4">
                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <InitialsAvatar name='Andy Cole' />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-6">
                                <p className="fw-bold mb-1">Andy Cole</p>
                                <p className='mb-0'>andy@email.com</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-5 col-xs-5">
                                <button className="btn btn-primary">Retry Download</button>
                            </div>
                        </div>
                        <div className="row align-items-center mb-4">
                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <InitialsAvatar name='Bob Cole' />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-6">
                                <p className="fw-bold mb-1">Bob Cole</p>
                                <p className='mb-0'>bob@email.com</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-5 col-xs-5">
                                <button className="btn btn-primary">Retry Download</button>
                            </div>
                        </div>
                        <div className="row align-items-center mb-4">
                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <InitialsAvatar name='George Smith' />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-6">
                                <p className="fw-bold mb-1">George Smith</p>
                                <p className='mb-0'>george@email.com</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-5 col-xs-5">
                                <button className="btn btn-primary">Retry Download</button>
                            </div>
                        </div>
                        <div className="row align-items-center mb-4">
                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <InitialsAvatar name='George Smith' />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-6">
                                <p className="fw-bold mb-1">George Smith</p>
                                <p className='mb-0'>george@email.com</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-5 col-xs-5">
                                <button className="btn btn-white">View Statement</button>
                            </div>
                        </div>
                    </div>
                    {/*<Navigate path='/dashboard/statement/generate/preview'>*/}
                    {/*    <button className="btn btn-primary mt-5">Continue <i className="bi bi-arrow-right"/></button>*/}
                    {/*</Navigate>*/}
                </div>
                <button className="btn btn-primary mt-5 w-25 mobile-full-width">Generate</button>
            </div>
        </div>
    );
};

export default StatementGenerationPreview;